'use strict';

import React, {Component} from 'react';

class ControllerWrapper extends Component {
	constructor(props) {
		super(props);
		this.c = null;
		this.el = null;
		this.state = {};
	}

	static initController() {
		throw new Error('NOT IMPLEMENTED');
	}

	async componentDidMount() {
		let c = this.constructor.initController();
		await c.render({container: this.el});
		this.c = c;
	}

	componentWillUnmount() {
		if (this.c) {
			this.c.destroy();
		}
	}

	render() {
		return <div ref={el => this.el = el}/>;
	}

	static wrap(Controller) {
		class WrappedController extends this {
			static initController() {
				return new Controller();
			}
		}

		return <WrappedController/>
	}
}

export default ControllerWrapper;